// lib
import React, { useState, useRef, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

import ADND from '@aytm/lib/adnd/ADND'

// components

// styles
import style from '@aytm/app/stats/page/sidebar/components/styles/CustomQuestion.module.scss'

const PinnedCustomQuestion = ({ item, disabled, addCustomQuestion, removePinnedQuestion, onDNDStart, onDNDEnd }) => {
  const [blocked, setBlocked] = useState(false)

  const timer = useRef(null)

  const dndListItemRef = useRef()

  const createCustomQuestion = useCallback(() => Object.assign({}, item.data), [item])

  const onClick = useCallback(() => {
    setBlocked(true)

    const question = createCustomQuestion()
    addCustomQuestion(question)

    timer.current && clearTimeout(timer.current)
    timer.current = setTimeout(() => setBlocked(false), 1000)

    return () => timer.current && clearTimeout(timer.current)
  }, [addCustomQuestion, createCustomQuestion])

  const dndListItem = disabled
    ? null
    : ADND.sources
        .data({
          type: 'pinned-question-custom',
          clearDragImage: false
        })
        .onStart(onDNDStart)
        .onEnd(onDNDEnd)
        .fetchData(createCustomQuestion)

  useEffect(() => {
    if (dndListItem) dndListItem.connect(dndListItemRef.current)

    return () => {
      if (dndListItem) dndListItem.disconnect()
    }
  }, [dndListItem])

  return (
    <div ref={dndListItemRef} className={`${style.row} p-fluid`}>
      {!disabled && 'function' == typeof removePinnedQuestion ? (
        <span className={style.delete} onClick={() => removePinnedQuestion(item.index)}>
          <i className="icon-aytmfd-delete" />
        </span>
      ) : null}
      <div className={style.button} onClick={blocked || disabled ? null : onClick}>
        <span className={style['button-text']}>
          {item.icon ? <i className={`icon-aytmfd-${item.icon}`} /> : null}
          <span dangerouslySetInnerHTML={{ __html: item.text }}></span>
        </span>
        {disabled ? (
          <span className={style['button-lock-icon']}>
            <i className="icon-aytmfd-lock" />
          </span>
        ) : (
          <span className={style['button-handle']}>
            <i className="icon-aytmfd-handle" />
          </span>
        )}
      </div>
    </div>
  )
}

PinnedCustomQuestion.propTypes = {
  item: PropTypes.object,
  disabled: PropTypes.bool,
  addCustomQuestion: PropTypes.func,
  removePinnedQuestion: PropTypes.func,
  onDNDStart: PropTypes.func,
  onDNDEnd: PropTypes.func
}

PinnedCustomQuestion.displayName = 'PinnedCustomQuestion'

export default PinnedCustomQuestion

ADND().connect()
